// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"Page_style_pageWrap__2vIz_"};